export default "__VITE_ASSET__D9Cfb945__"